export const VERSIONS_FETCHED = "VERSIONS_FETCHED";
export const COUNTRIES_FETCHED = "COUNTRIES_FETCHED";
export const SELECTED_VERSIONS_UPDATED = "SELECTED_VERSIONS_UPDATED";
export const APP_LIST = "APP_LIST";
export const SELECTED_APP = "SELECTED_APP";
export const SELECTED_COUNTRIES_UPDATED = "SELECTED_COUNTRIES_UPDATED";
export const START_DATE_FETCHED = "START_DATE_FETCHED";
export const SELECTED_DATE_RANGE_UPDATED = "SELECTED_DATE_RANGE_UPDATED";
export const DEVELOPER_COUNTRY_DISTRIBUTION = "DEVELOPER_COUNTRY_DISTRIBUTION";
export const RESET_DEV_ANALYTICS_FILTERS = "RESET_DEV_ANALYTICS_FILTERS";
export const CHART_DATA_FETCHED = "CHART_DATA_FETCHED";
